export default __webpack_public_path__ + "static/springandsummer (3)-0507deaf7fcaa92d387cc3bd9f34b27a.jpeg";